module.exports = __webpack_public_path__ + "img/wxjl-icon.7cef1644.png";